import * as RadixPopover from '@radix-ui/react-popover';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { Command } from '@air/cmdk';
import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

const comboboxContent = tailwindVariants({
  base: 'z-portal flex max-h-[var(--radix-popover-content-available-height)] w-full radix-side-bottom:animate-slide-up radix-side-top:animate-slide-down flex-col overflow-y-auto rounded-4 ads:border-default ads:bg-raised bg-surface-1 shadow-popover outline-none dark:border dark:border-gray-5',
  defaultVariants: {
    size: 'small',
  },
  variants: {
    size: {
      large: 'min-w-[240px]',
      small: 'min-w-[216px]',
    },
  },
});

export type ComboboxVariants = VariantProps<typeof comboboxContent>;

export type ComboboxContentProps = RadixPopover.PopoverContentProps &
  ComboboxVariants &
  Pick<ComponentPropsWithoutRef<typeof Command>, 'shouldFilter'>;

export const ComboboxContent = forwardRef<HTMLDivElement, ComboboxContentProps>(
  ({ children, className, collisionPadding = 8, shouldFilter, sideOffset = 8, size, ...restOfProps }, ref) => {
    return (
      <RadixPopover.Portal>
        <RadixPopover.Content
          className={comboboxContent({ className, size })}
          collisionPadding={collisionPadding}
          data-testid="COMBOBOX_CONTENT"
          sideOffset={sideOffset}
          {...restOfProps}
          ref={ref}
        >
          <Command shouldFilter={shouldFilter}>{children}</Command>
        </RadixPopover.Content>
      </RadixPopover.Portal>
    );
  },
);

ComboboxContent.displayName = 'ComboboxContent';
